import httpClient from './httpClient';
import type { UserProfile, UpdateProfileRequest, ChangePasswordRequest } from '@/types/settings';

export async function getProfile(): Promise<UserProfile> {
  const acqResponse = await httpClient.get<UserProfile>('/settings/profile');
  return acqResponse.data;
}

export async function updateProfile(acqData: UpdateProfileRequest): Promise<UserProfile> {
  const acqResponse = await httpClient.put<UserProfile>('/settings/profile', acqData);
  return acqResponse.data;
}

export async function changePassword(acqData: ChangePasswordRequest): Promise<void> {
  await httpClient.post('/settings/change-password', acqData);
}
